import { Provider } from '@angular/core';
import { QualityControlRepositoryPort } from '../domain/repositories/quality-control.repository.port';
import { QualityControlRepository } from './repositories/quality-control.repository';

export const QUALITY_CONTROL_PROVIDERS: Provider[] = [
  {
    provide: QualityControlRepositoryPort,
    useClass: QualityControlRepository,
  },
];
